import { createFileRoute } from '@tanstack/react-router';

import { EditExchangeRate } from './-components';

export const Route = createFileRoute(
  '/admin/exchange-rates/_auth/$exchangeRateId',
)({
  component: EditExchangeRate,
});
